import React from "react";
import { InboxIcon, FilterIcon, SearchCheckIcon, MessagesSquareIcon, ScanSearchIcon, WorkflowIcon, FileTextIcon, ActivityIcon, BoxIcon } from "lucide-react";
import { AgentCategoryId } from "../../types/platform";
const ICONS: Record<AgentCategoryId, BoxIcon> = {
  intake: InboxIcon,
  qualification: FilterIcon,
  enrichment: SearchCheckIcon,
  communication: MessagesSquareIcon,
  diligence: ScanSearchIcon,
  workflow: WorkflowIcon,
  documents: FileTextIcon,
  monitoring: ActivityIcon
};
export function AgentIcon({
  category,
  className
}: {
  category: AgentCategoryId;
  className?: string;
}) {
  const Icon = ICONS[category];
  return <Icon className={className} aria-hidden="true" data-id="element-795" data-mp="1bwdmyxmbltq3" />;
}